// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { ParameterDO } from '../../../requests';

interface Props {
  formValues: {
    data: Partial<ParameterDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
            readOnly
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Description</b> &nbsp;
          </label>
          <textarea
            className="inputNew"
            style={{ width: '80%' }}
            name="description"
            rows={5}
            cols={40}
            value={data.description || ''}
            onChange={props.onChange}
            required
            readOnly
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Value</b> &nbsp;
          </label>
          <textarea
            className="inputNew"
            style={{ width: '80%' }}
            name="value"
            rows={5}
            cols={40}
            value={data.value || ''}
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
    </fieldset>
  );
}
